import * as React from 'react';

import Reporting32 from './Reporting32';

export const reporting32 = () => <Reporting32 />;

export default {
    title: 'Icon/Logo/Reporting32',
    component: Reporting32,
    parameters: {
        notes: "`import Reporting32 from 'box-ui-elements/es/icon/logo/Reporting32';`",
    },
};
